import { inject, Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { OneSignalService } from '@ninety/platform/services/services/onesignal.service';

import { OneSignalActions } from './one-signal.actions';

@Injectable()
export class OneSignalEffects {
  private readonly oneSignalService = inject(OneSignalService);

  /** Bridges `OneSignalService` click events to the OneSignal clicked action (services -> state inversion). */
  notificationClicked$ = createEffect(() =>
    this.oneSignalService.notificationClicked$.pipe(map(event => OneSignalActions.clicked({ event })))
  );

  /** Bridges `OneSignalService` foreground-display events to the displayed action (services -> state inversion). */
  notificationDisplayed$ = createEffect(() =>
    this.oneSignalService.notificationDisplayed$.pipe(map(event => OneSignalActions.notificationDisplayed({ event })))
  );
}
